import { SkyButton, SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { failureMessage } from "@/lib/api";

/**
 * #1398: a re-read that failed while rows are on screen (offline, a Retry, an invalidation). The
 * rows stay and this bar says so, as the Runs and Schedules lists do; only a failed FIRST read
 * replaces a list with its full error. `things` is the list's plural noun ("instances"), in the
 * screen's own words. `empty`: the rows kept are none, so there is nothing on screen to point to.
 */
export function RefreshErrorBar({
  things,
  error,
  onRetry,
  empty = false,
  testId,
}: {
  things: string;
  error: unknown;
  onRetry: () => void;
  empty?: boolean;
  testId?: string;
}) {
  const kept = empty ? "This list may be out of date." : `The ${things} on screen are still here.`;
  return (
    <SkyMessageBar
      intent="warning"
      layout="multiline"
      title={`We could not refresh the ${things}.`}
      message={`${failureMessage(error, "Try again.")} ${kept}`}
      actions={
        <SkyButton size="small" onClick={onRetry}>
          Try again
        </SkyButton>
      }
      testId={testId}
    />
  );
}
